export const TranslationIdMap = '';

export const TranslationKeyMap = {
    '_130_LOGIN': 'Login',
    '_7162_PLACEHOLDER_LOGIN_NOTICE': 'PLACEHOLDER_login_notice',
    '_72_USERNAME': 'Username',
    '_640__FIELD_LABEL__IS_A_REQUIRED_FIELD__PLEASE_ENTER_A__FIELD_LABEL_': '{{field_label}} is a required field. Please enter a {{field_label}}.',
    '_55_PASSWORD': 'Password',
    '_9632_NEXT': 'Next',
    '_129_FORGOT_PASSWORD': 'Forgot Password',
    '_704_UNKNOWN_ERROR': 'Unknown error',
    '_11035_LOGIN_USING_SSO': 'Login using SSO'
};
